import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { LogoutService } from 'src/app/shared/services/logout/logout.service';
import { Firestore, collection, collectionData, doc, docData, getDocs, limit, query, where } from '@angular/fire/firestore';
import { firstValueFrom, takeUntil } from 'rxjs';
import { SponsorProps } from 'src/app/modules/list-sponsors/@types/sponsor';
import { TypeModule } from 'src/app/enums/type-module';

@Injectable({
    providedIn: 'root'
})

export class DaoSponsorsService {
    refGetModule = null;
    
    constructor(
        private firestore: Firestore,
        private Slogout: LogoutService,
        private storage: StorageService
    ) { }

    getModule(eventId: string, moduleId: string, onResolve) {
        const ref = doc(this.firestore, `events/${eventId}/modules/${moduleId}`);
        this.refGetModule = docData(ref).pipe(takeUntil(this.Slogout.logoutSubject)).subscribe((module) => {
            onResolve(module);
        })
    }

    async fetchSponsorsByEvent(eventId: string) {
        const ref = collection(this.firestore, `events/${eventId}/modules`);
        const refQ = query(ref, where('type', '==', TypeModule.SPONSOR), limit(1));
        const docs = await getDocs(refQ)

        if (!docs) {
            console.error('No sponsor type module found.');
            return [];
        }
            
        if (docs?.empty) {
            return [];
        }

        const firstDocId = docs.docs[0]?.id;
        const sponsorsRef = collection(this.firestore, `events/${eventId}/modules/${firstDocId}/sponsors`);
        return firstValueFrom(collectionData(sponsorsRef));
    }

    fetchSponsors(eventId: string, moduleId: string, onResolve: (sponsors: SponsorProps[]) => void) {
        const ref = collection(this.firestore, `events/${eventId}/modules/${moduleId}/sponsors`);
        collectionData(ref).pipe(takeUntil(this.Slogout.logoutSubject)).subscribe((sponsors: SponsorProps[]) => {
            onResolve(sponsors);
        });
    }

    getSponsor(eventId: string, moduleId: string, sponsorId: string, onResolve: (sponsor: SponsorProps) => void) {
        const ref = doc(this.firestore, `events/${eventId}/modules/${moduleId}/sponsors/${sponsorId}`);
        docData(ref).pipe(takeUntil(this.Slogout.logoutSubject)).subscribe((sponsor: SponsorProps) => {
            onResolve(sponsor);
        })
    }
}
